import state from './authState';
import actions from './actions';
import mutations from './mutations';
const Auth = {
    state,
    actions,
    mutations
};
export default Auth;
